<template>
  <div
    id="chatbox"
    ref="chatbox"
    :style="{ 'overflow-y': isMobile ? 'initial' : 'auto' }"
    @scroll="onMessageScroll"
    style="height: calc(100vh - 64px)"
    v-resize="onResizeChatbox"
  >
    <!-- v-resize="onResizeChatbox"
    height: chatboxHeight,  -->
    <!-- <div v-html="debug" style="position:absolute; color:red;z-index: 10;background: white"></div> -->
    <template v-if="selectedUser">
      <div
        class="primary white--text"
        style="top: 0; background: #ff9d85;width: 100%;z-index: 3"
        :style="{ top: isMobile ? '56px' : '0px', position: isMobile ? 'fixed' : 'absolute' }"
      >
        <v-layout class="ml-2 mt-2 mb-2" style="display: -webkit-box;">
          <v-flex style="display: flex;">
            <v-btn
              flat
              dark
              fab
              small
              class="ma-0 btn-back extra-small"
              @click="$emit('onClose')"
              v-show="isMobile"
            >
              <v-icon medium>keyboard_arrow_left</v-icon>
            </v-btn>
            <div v-if="!selectedUser.group_id" class="title white--text text-truncate mt-2">
              {{ selectedUser.first_name }} {{ selectedUser.last_name }}
            </div>
            <div v-else class="title white--text text-truncate mt-2">
              {{ selectedUser.group_name }}
            </div>
            <div class="my-auto">
              <v-menu offset-y open-on-hover>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="white">expand_more</v-icon>
                </template>
                <v-list>
                  <template v-if="$store.state.livechat.app == 'facebook'">
                    <v-list-tile v-if="allowChecked" @click="() => retrieveChat()">
                      <v-list-tile-title
                        :class="[allowChecked ? 'primary--text' : 'grey--text']"
                        :disabled="!allowChecked"
                        :style="{ cursor: allowChecked ? 'pointer' : 'default' }"
                        style="width: fit-content"
                      >
                        {{ $t('Retrieve chat history') }}
                      </v-list-tile-title>
                      <v-list-tile-action>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <div
                              class="primary--text ml-2"
                              @click.prevent.stop="gotoLink()"
                              v-on="on"
                            >
                              <i
                                style="font-size: 18px;"
                                :style="{ color: allowChecked ? '#ed1e79' : '#969595' }"
                                class="fas fa-question-circle"
                              ></i>
                            </div>
                          </template>
                          <span>{{ $t('Can look back up to {day} days ago', { day: 30 }) }}</span>
                        </v-tooltip>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-list-tile v-else>
                      <v-list-tile-title
                        :class="[allowChecked ? 'primary--text' : 'grey--text']"
                        :disabled="!allowChecked"
                        :style="{ cursor: allowChecked ? 'pointer' : 'default' }"
                        style="width: fit-content"
                      >
                        {{ $t('Retrieve chat history') }}
                      </v-list-tile-title>
                      <v-list-tile-action>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <a
                              href="https://blog.zwiz.app/all-features-on-all-in-1-chat/"
                              target="_blank"
                              class="primary--text ml-2"
                              v-on="on"
                            >
                              <i
                                style="font-size: 18px;"
                                :style="{ color: allowChecked ? '#ed1e79' : '#969595' }"
                                class="fas fa-question-circle"
                              ></i>
                            </a>
                          </template>
                          <span>{{ $t('Can look back up to {day} days ago', { day: 30 }) }}</span>
                        </v-tooltip>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-list-tile @click="() => retrieveTags()">
                      <v-list-tile-title
                          class="primary--text"
                          style="width: fit-content"
                        >
                          {{ $t('Retrieve Tags') }}
                        </v-list-tile-title>
                    </v-list-tile>
                  </template>
                  <v-list-tile
                    @click="unreadMessage()"
                    :disabled="!adminread"
                    :class="[adminread ? 'primary--text' : 'grey--text']"
                  >
                    <v-list-tile-title>
                      {{ $t('Unread message') }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </div>
          </v-flex>
          <v-flex shrink>
            <v-btn
              flat
              dark
              fab
              small
              class="ma-0 btn-back"
              @click="$emit('onShowTool')"
              v-show="isMobile"
            >
              <v-icon medium>settings_applications</v-icon>
            </v-btn>
            <div v-show="!isMobile">
              <v-btn
                color="white"
                small
                outline
                @click="endSession"
                v-if="selectedUser.type == 'admin'"
                style="line-height: 0"
                >{{ $t('Switch to bot') }}</v-btn
              >
              <v-btn
                color="white"
                small
                outline
                @click="openSession"
                v-else-if="selectedUser.type == 'bot'"
                style="line-height: 0"
                >{{ $t('Switch to admin') }}</v-btn
              >
            </div>
          </v-flex>
        </v-layout>

        <v-spacer></v-spacer>

        <!-- <div class="caption red text-xs-center py-1" v-if="$store.state.livechat.app == 'facebook' && !selectedUser.is_24hr_available">
          {{ $t("Cannot send a message, the user's response is over 24 hours.") }}
        </div> -->
      </div>
      <div
        id="chatbox-container"
        style="position: relative"
        :style="{
          'padding-bottom': chatinputHeight + 'px',
          'margin-top': isMobile ? '56px' : '0px',
          top: isMobile ? '0px' : '64px'
        }"
      >
        <div class="text-xs-center mt-4" v-if="loadingFirst">
          <v-progress-circular indeterminate color="grey" small :width="2"></v-progress-circular>
        </div>
        <template v-else-if="messages.length > 0">
          <div id="messages">
            <template v-if="isMobile">
              <div
                class="text-xs-center"
                style="background: #eee; padding-top: 10px; padding-bottom: 10px"
                @click="onLoadmore"
              >
                <template v-if="loadmore">
                  <v-progress-circular
                    indeterminate
                    color="grey"
                    small
                    class="mr-2"
                    :width="2"
                  ></v-progress-circular
                  >Loading
                </template>
                <template v-else @click="onLoadmore">Click to load more conversation</template>
              </div>
            </template>
            <template v-else>
              <div
                v-if="loadmore"
                class="text-xs-center"
                style="background: #eee; padding-top: 10px; padding-bottom: 10px"
              >
                <v-progress-circular
                  indeterminate
                  color="grey"
                  small
                  class="mr-2"
                  :width="2"
                ></v-progress-circular
                >Loading
              </div>
            </template>
            <template v-for="(message, index) in messages">
              <message-item
                :id="`message_${message.id}`"
                :ref="`message_${message.id}`"
                v-if="messages"
                :key="'message-' + message.id + message.userid + message.pageid"
                v-model="messages[index]"
                :receiver="selectedUser"
                :app="selectedUser.app"
                @onQuote="onQuote"
              ></message-item>
            </template>
            <template v-for="(message, index) in tmp_messages">
              <message-item
                :id="`message_${message.id}`"
                :ref="`message_${message.id}`"
                v-if="tmp_messages"
                :key="'message-' + message.id + message.userid + message.pageid"
                v-model="tmp_messages[index]"
                :receiver="selectedUser"
                :app="selectedUser.app"
                @onQuote="onQuote"
              ></message-item>
            </template>
          </div>
        </template>
        <template v-else>
          <v-layout column justify-center fill-height>
            <div class="text-xs-center mt-5" style="color: #eee">
              <img src="/static/img/assets/livechat/no_message.png" alt />
              <p>No message</p>
            </div>
          </v-layout>
        </template>
      </div>
      <chat-input
        id="chatinput"
        :is_leave_group="selectedUser.is_leave_group"
        :is_blocked="selectedUser.is_blocked"
        :app="selectedUser.app"
        :quote="quote"
        v-model="selectedUser"
        @onSendMessage="onSendMessage($event)"
        @onsetStatusError="onsetStatusError"
        @emitSocket="emitSocket($event)"
      >
        <template slot="header">
          <div class="text-xs-center">
            <template v-if="!isAutoRefresh">
              <v-btn small round color="primary" @click="gotobottom" depressed>
                <v-icon class>arrow_drop_down</v-icon>Go to bottom
              </v-btn>
            </template>

            <template v-if="app == 'line' && showLine30Sec">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-chip
                    style="vertical-align: middle;"
                    small
                    round
                    color="primary"
                    v-on="on"
                    depressed
                    class="white--text pl-0"
                  >
                    <v-icon class="mr-2">schedule</v-icon>
                    <countdown :time="expectLine30Time * 60 * 1000" @end="onCountdownEnd">
                      <template slot-scope="props">
                        {{ props.minutes }}:{{ props.seconds }}
                        <span class="small">{{ $t('Minutes') }}</span>
                      </template>
                    </countdown>
                  </v-chip>
                </template>
                <span>{{
                  $t(
                    "Sending Messages in All-In-One Chat after 20 minutes of customer's response will count as a broadcast message on LINE OA"
                  )
                }}</span>
              </v-tooltip>
            </template>

            <template v-if="app === 'line' && quote">
              <div class="quote-box">
                <message-viewer
                  key="quote-message"
                  v-model="quote.parsedMessage"
                  :maxLength="200"
                  :size="'small'"
                  :showProfile="false"
                  :channel="app"
                  align="left"
                ></message-viewer>
                <v-btn
                  small
                  icon
                  @click="quote = null"
                  style="position: absolute; top: 0; right: 0"
                >
                  <v-icon small>close</v-icon>
                </v-btn>
              </div>
            </template>
          </div>
        </template>
      </chat-input>
    </template>
    <template v-else>
      <v-layout column justify-center fill-height>
        <div class="text-xs-center" style="color: #eee">
          <img src="/static/img/assets/livechat/no_user.png" alt />
          <p>Select a user</p>
        </div>
      </v-layout>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import messageItem from './livechat-message'
import chatInput from './livechat-chatinput'
import MessageViewer from '@/components/elements/MessageViewer'
import api from '@/api'
import dayjs from 'dayjs'
import { cloneDeep } from 'lodash'
import io from 'socket.io-client'
import config from '@/config'
import EventBus from '@/utils/event-bus.js'

export default {
  props: ['value', 'isMobile', 'app'],
  data: function() {
    return {
      loadmore: false,

      chatboxHeight: 0,
      loading: false,
      maxTime: 10000,
      timer: '',
      isAutoRefresh: false,
      currentIndex: null,

      offset: 0,
      limit: 25,
      messages: [],
      tmp_messages: [],
      // oldMessages: [],
      endChatlog: false,

      windowHeight: 0,

      newMessage: null,
      chatinputHeight: 0,
      debug: '',
      loadingFirst: true,
      showLine30Sec: false,
      expectLine30Time: null,
      latestMessageId: null,
      loadingMessage: false,
      pageSize: 25,
      isDestroy: false,
      timestamp: dayjs().format('x'),
      quote: null,
      allowChecked: true,
      adminread: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      selectedUser: 'getCurrentUser',
      isUnlock: 'getUnlockLivechat'
    }),
    welcomeMessage() {
      let { messages } = this.$store.getters.welcomeMessage(this.selectedUser.app)
      return messages
    }
  },
  components: {
    'message-item': messageItem,
    'chat-input': chatInput,
    MessageViewer
  },
  mounted: async function() {
    const vm = this
    vm.resetChatlog()
    vm.loadingFirst = true

    vm.socket = io(config.socketUrl, {
      transports: ['websocket']
    })

    const socketEvent = `livechat:getchatlog:${vm.$store.state.livechat.pageid}:${
      vm.selectedUser.group_id ? vm.selectedUser.group_id : vm.selectedUser.userid
    }`

    vm.socket.on(socketEvent, message => {
      if (vm.$store.state.livechat.app === 'instagram') {
        vm.tmp_messages = []
        vm.messages.push(message)
      } else if (vm.$store.state.livechat.app === 'line' && message.intent === '{audio}') {
        const chatData = JSON.parse(message.questiondata)
        vm.tmp_messages.push({
          ...message,
          questiondata: `${config.serverUrl}line/content/audio/${message.pageid}/${chatData.id}`
        })
      } else {
        vm.tmp_messages.push(message)
      }
      message.id = `${vm.currentIndex.id}${message.message_id || ''}${dayjs().format('x')}`
      vm.snapBottom('onSendMessage')
      if (vm.latestMessageId == null || vm.latestMessageId != message.id) {
        vm.latestMessageId = message.id
        let sec = dayjs().diff(dayjs(message.timestamp), 'minute', true)
        if (
          sec <= 20 &&
          (message.answerby == null ||
            message.answerby == '' ||
            (message.answerby == 'bot' && message.messagetype == 'noreply'))
        ) {
          vm.expectLine30Time = 20 - sec
          vm.showLine30Sec = true
        }
      }
    })
    vm.socket.on('connect', async () => {
      let roomName = `pageid:${vm.$store.state.livechat.pageid}`
      if (vm.$store.state.SOCKET_GROUP_GT817.includes(vm.$store.state.livechat.pageid)) {
        roomName = 'gt817'
      }
      vm.socket.emit('join-room', roomName, async error => {
        if (error) {
          console.log(`join-room error`, error)
        }
        await vm.getLastedMessages()
        vm.loadingFirst = false
        if (vm.isMobile) {
          document.body.onscroll = function() {
            vm.onMessageScroll()
          }
        }
        vm.snapBottom()
        console.log('[socket connected]: ', vm.socket.connected)
      })
    })
    vm.socket.on('disconnect', reason => {
      console.log('[socket disconnected]: ', reason)
    })
    vm.socket.on('connect_error', error => {
      vm.socket.io.opts.transports = ['websocket']
      console.error('[connect error]: ', error)
    })

    EventBus.$on('send:message', e => {
      this.onSendMessage(e)
    })

    EventBus.$on('update:chat', e => {
      this.emitSocket(e)
    })

    this.$on('hook:beforeDestroy', () => {
      EventBus.$off('send:message')
      EventBus.$off('update:chat')
    })

    // if (!vm.timer) vm.timer = setInterval(vm.getLastedMessages, vm.maxTime)
    if (vm.$store.state.livechat.app === 'facebook') {
      vm.checkAllowSyncFbConversion()
    }
    vm.adminread = vm.selectedUser.adminread
  },
  destroyed() {
    const vm = this
    vm.socket.disconnect()
  },
  // mounted: function() {
  //   console.log('start mounted')

  //   console.log('end mounted')
  // },
  async updated() {
    // this.snapBottom()
  },
  methods: {
    checkAllowSyncFbConversion() {
      if (this.$localStorage.get(`syncChat.${this.selectedUser.userid}`)) {
        this.allowChecked = false
      }
    },
    updateChatlogSetting(messages) {
      let tmp_messages = cloneDeep(messages)
      tmp_messages.splice(0, tmp_messages.length - 100)
      let chatlogSetting = this.$localStorage.get('chatlogSetting') || '{}'
      chatlogSetting = JSON.parse(chatlogSetting)

      // {
      //    xxx: {
      //      chatlog: {
      //         xxx: {
      //           expried: xxx,
      //           messages: []
      //         }
      //       }
      //    }
      // }

      if (!chatlogSetting.hasOwnProperty(this.$store.state.livechat.pageid)) {
        chatlogSetting[this.$store.state.livechat.pageid] = {
          chatlog: {}
        }
      }

      if (chatlogSetting[this.$store.state.livechat.pageid].chatlog) {
        chatlogSetting[this.$store.state.livechat.pageid].chatlog[this.selectedUser.userid] = {
          expired: null,
          messages: tmp_messages
        }
      }

      this.$localStorage.set('chatlogSetting', JSON.stringify(chatlogSetting))
    },
    onCountdownEnd() {
      this.showLine30Sec = false
      this.expectLine30Time = null
    },
    onResizeChatbox: function() {
      var vm = this
      vm.$nextTick(function() {
        if (this.isMobile) {
          vm.chatboxHeight = 'auto'
          // vm.chatinputHeight = 0
        } else {
          vm.chatboxHeight =
            window.innerHeight - document.getElementById('main_toolbar').clientHeight - 5 + 'px'
        }
        if (document.getElementById('chatinput')) {
          vm.chatinputHeight = document.getElementById('chatinput').clientHeight
        }
        vm.debug =
          `Chatbox Height: ${vm.chatboxHeight}<br>` +
          `Input Height: ${vm.chatinputHeight}<br>` +
          `Screen Height: ${screen.height}<br>` +
          `Main Toolbar: ${document.getElementById('main_toolbar').clientHeight}<br>` +
          `Window: ${window.innerHeight}<br>`
      })
    },
    onsetStatusError(id, messagesError) {
      const vm = this
      let findIndex = vm.tmp_messages.findIndex(element => element.id == id)
      vm.$set(vm.tmp_messages, findIndex, {
        ...vm.tmp_messages[findIndex],
        status: 'error',
        messagesError: messagesError
      })
    },
    async onSendMessage(payload) {
      const vm = this
      vm.quote = null
      vm.onCountdownEnd()
      vm.log('onSendMessage', payload)
      vm.tmp_messages.push(payload)
      // vm.emitSocket(payload)
      await vm.snapBottom('onSendMessage')
      if ((this.selectedUser && !this.selectedUser.adminread) || !this.adminread) {
        vm.adminreadMessage()
      }
      // this.log(payload)
    },
    emitSocket(payload) {
      let vm = this
      this.socket.emit('livechat:forward-getchatlog', payload, response => {
        const user = vm.$store.state.livechat.userlist[vm.$store.state.livechat.type].users.filter(
          user => user.userid === payload.userid
        )
        if (user.length > 0 && !user[0].adminread) {
          user[0].adminread = true
        }
        /* Handle response, if any */
        // console.error('[response]: ', response)
      })
    },
    getLastedMessages: async function() {
      if (this.isDestroy) {
        if (this.timer) clearInterval(this.timer)
        return false
      }
      this.log('call getLastedMessages', this.isAutoRefresh)
      let limit = this.pageSize

      if (this.loadingMessage || !this.isAutoRefresh) return false
      this.loadingMessage = true

      if (this.messages.length == 0) {
        limit = this.pageSize
      }
      if (!this.selectedUser) {
        return false
      }
      try {
        await this.getUserMessages(0, limit, true)
        this.onResizeChatbox()
        if (this.isAutoRefresh && document.getElementById('messages')) {
          // $('#chatbox').animate({ scrollTop: document.getElementById('messages').clientHeight })
          await this.snapBottom('getLastedMessages')
        }
      } catch (error) {}
      // this.updateChatlogSetting(this.messages)
      this.loadingFirst = false
      this.loadingMessage = false
      //this.log('loaded', this.selectedUser.userid)
    },
    getUserMessages: async function(offset, limit, latest) {
      let vm = this
      return new Promise((resolve, reject) => {
        if (!vm.isUnlock || vm.selectedBot == null || vm.selectedUser == null || vm.loading) {
          vm.log('reject load')
          resolve()
          return false
        }
        vm.loading = true
        let data = {}
        let apiName = ''
        if (vm.selectedUser.source_type) {
          apiName = 'getUserMessagesGroup'
          data = {
            pageid: vm.$store.state.livechat.pageid,
            groupId: vm.selectedUser.group_id,
            offset: offset,
            limit: limit,
            app: vm.selectedUser.app
          }
        } else {
          apiName = 'getUserMessages'
          data = {
            pageid: vm.$store.state.livechat.pageid,
            userid: vm.selectedUser.userid,
            offset: offset,
            limit: limit,
            adminid: vm.$store.state.userid,
            app: vm.selectedUser.app
          }
        }
        this.log('loading', apiName)
        api[apiName](data, function(error, response) {
          if (error) {
            vm.loading = false
            reject(error)
          }
          if (apiName === 'getUserMessagesGroup') {
            response.data = response
          }
          if (response.data) {
            let data = response.data
            // data = vm.transformChatlogs(data)
            if (!latest && data.length == 0) {
              vm.endChatlog = true
            }
            if (latest) {
              // หาข้อความที่ส่งไม่เกิน 30 นาที
              if (data && data.length > 0) {
                let latest_message = data[0]
                if (vm.latestMessageId == null || vm.latestMessageId != latest_message.id) {
                  vm.latestMessageId = latest_message.id
                  let sec = dayjs().diff(dayjs(latest_message.timestamp), 'minute', true)
                  if (
                    sec <= 20 &&
                    (latest_message.answerby == null ||
                      latest_message.answerby == '' ||
                      (latest_message.answerby == 'bot' && latest_message.messagetype == 'noreply'))
                  ) {
                    vm.expectLine30Time = 20 - sec
                    vm.showLine30Sec = true
                  }
                }
              }
              if (data && data.length > 0) {
                if (vm.messages.length == 0) {
                  // ไม่มี chatlog มาก่อน
                  var messages = data.reverse()
                  vm.messages = []
                  messages.forEach(function(el) {
                    vm.messages.push(el)
                  })
                  vm.loading = false
                  vm.getCurrentIndex()
                  resolve()
                } else {
                  vm.log('currentIndex', data[0], vm.currentIndex)
                  if (vm.currentIndex && data[0].id == vm.currentIndex.id) {
                    // มี chatlog และข้อความล่าสุดเท่ากับที่มี
                    vm.loading = false
                    vm.getCurrentIndex()
                    vm.log('Not change')
                    resolve()
                  } else {
                    if (vm.currentIndex) {
                      vm.tmp_messages = []
                      vm.messages = vm.messages.splice(0, vm.currentIndex.index)
                      let tmpIndex = data.findIndex(val => {
                        return val.id == vm.currentIndex.id
                      })

                      if (tmpIndex != -1) {
                        for (var i = tmpIndex; i >= 0; i--) {
                          vm.messages.push(data[i])
                        }

                        if (data[0]) {
                          vm.newMessage = data[0]
                        }
                      }
                    }
                    vm.loading = false
                    vm.getCurrentIndex()
                    resolve()
                  }
                }
              }
              let _messages = []
              for (let i = 0; i < vm.messages.length; i++) {
                const item = vm.messages[i]
                if (item.error_data && item.error_data != null) {
                  _messages.push({
                    ...item,
                    error_data: item.error_data === '{standby}' ? 'Standby Mode' : _.get(JSON.parse(item.error_data), 'error.message', ''),
                    status: item.error_data === '{standby}' ? 'standby' : 'error'
                  })
                } else if (vm.$store.state.livechat.app === 'line' && item.intent === '{audio}') {
                  const chatData = JSON.parse(item.questiondata)
                  _messages.push({
                    ...item,
                    questiondata: `${config.serverUrl}line/content/audio/${item.pageid}/${chatData.id}`
                  })
                } else {
                  _messages.push(item)
                }
              }

              vm.messages = []
              vm.messages = _messages

              vm.loadingFirst = false
            } else {
              vm.messages = data.reverse()
              vm.getCurrentIndex()
              vm.loading = false
              resolve()
            }
          } else {
            vm.loading = false
            vm.getCurrentIndex()
            resolve()
          }
        })
      })
    },
    transformChatlogs(data) {
      let messages = []
      let welcome = []
      try {
        var rand = Math.floor(Math.random() * this.welcomeMessage.length)
        welcome = this.welcomeMessage[rand]
      } catch (error) {}
      try {
        messages = data.map(message => {
          if (message.intent == '{welcome}') {
            welcome = welcome.map(message => {
              return this.replaceShopurl(message)
            })
            message.messagedata = JSON.stringify(welcome)
          }
          return message
        })
      } catch (error) {}

      return messages
    },
    replaceShopurl(data) {
      try {
        if (this.selectedUser && this.selectedUser.shopurl) {
          switch (data.type) {
            case 'generic':
              data.data.forEach(message => {
                let buttons = message.buttons.map(button => {
                  if (button.type == 'web_url') {
                    button.url = button.url.replace('{shopurl}', this.selectedUser.shopurl)
                  }
                  return button
                })
                message.buttons = buttons
              })
              break
            case 'button':
              let buttons = data.buttons.map(button => {
                if (button.type == 'web_url') {
                  button.url = button.url.replace('{shopurl}', this.selectedUser.shopurl)
                }
                return button
              })
              data.buttons = buttons
              break

            default:
              break
          }
        }
      } catch (error) {}

      return data
    },
    getCurrentIndex() {
      if (this.messages.length > 0) {
        this.currentIndex = {
          id: this.messages[this.messages.length - 1].id,
          index: this.messages.length - 1
        }
      }
    },
    onMessageScroll: function() {
      let scrollPosition = 0
      if (this.isMobile) {
        scrollPosition = window.pageYOffset + window.innerHeight
        let totalHeight = document.body.scrollHeight
        // this.log(
        //   'totalHeight',
        //   totalHeight,
        //   'scrollPosition',
        //   scrollPosition,
        //   totalHeight == scrollPosition
        // )
        if (totalHeight == scrollPosition) {
          this.isAutoRefresh = true
          this.limit = this.pageSize
        } else {
          this.isAutoRefresh = false
        }
        // this.log(scrollPosition, totalHeight)
        return false
      } else {
        let messages = document.getElementById('chatbox')
        scrollPosition = messages.scrollTop
        let chatboxHeight = messages.clientHeight
        let totalHeight = messages.scrollHeight
        // this.log(
        //   'totalHeight',
        //   totalHeight,
        //   'scrollPosition',
        //   scrollPosition,
        //   'chatboxHeight',
        //   chatboxHeight,
        //   'scrollPosition + chatboxHeight',
        //   scrollPosition + chatboxHeight,
        //   totalHeight <= scrollPosition + chatboxHeight
        // )
        if (totalHeight <= scrollPosition + chatboxHeight + 1) {
          this.isAutoRefresh = true
        } else {
          this.isAutoRefresh = false
        }
      }

      if (scrollPosition == 0) {
        this.onLoadmore()
          .then(() => {})
          .catch(error => {
            console.error(error)
          })
      }
    },
    async onLoadmore() {
      this.log('call loadmore', this.loadmore)
      if (this.loadmore) {
        return false
      }
      this.loadmore = true
      this.limit += this.pageSize
      let last_message = this.messages.length > 0 ? this.messages[0] : null
      try {
        await this.getUserMessages(this.offset, this.limit, false)
      } catch (error) {
        console.error(error)
      }
      try {
        if (last_message) {
          await this.$nextTick()
          this.log('last_message', last_message)
          this.goto(`message_${last_message.id}`)
        }
      } catch (error) {
        this.log(error)
      }
      this.loadmore = false
      return true
    },
    async snapBottom(from) {
      this.log('snap by ' + from)
      if (!this.isAutoRefresh || this.loadmore) {
        return false
      }
      await this.gotobottom()
    },
    async gotobottom() {
      await this.$nextTick()
      let messages = document.getElementById('messages')

      if (messages) {
        if (this.isMobile) {
          window.scrollTo(
            0,
            document.body.scrollHeight +
              (this.chatinputHeight == 0 ? 114 : this.chatinputHeight * 2)
          )
        } else {
          document
            .getElementById('chatbox')
            .scrollTo(0, document.getElementById('messages').clientHeight)
        }
      }
    },
    goto(refName) {
      var element = this.$refs[refName]
      if (element && element.length > 0) {
        var top = element[0].$el.offsetTop

        this.log(element, top)

        document.getElementById('chatbox').scrollTo(0, top)
      }
    },
    resetChatlog: function() {
      this.messages = []
      this.tmp_messages = []
      this.offset = 0
      this.limit = this.pageSize
      this.endChatlog = false
      this.loading = false
      this.loadmore = false
      this.isAutoRefresh = true
      this.newMessage = null
    },
    endSession: function() {
      this.$emit('endSession')
      const payload = {
        userid: this.selectedUser.userid,
        pageid: this.$store.state.livechat.pageid,
        user: this.selectedUser
      }
      this.socket.emit('livechat:forward-endconversation', payload, response => {
        /* Handle response, if any */
        console.error('[response]: ', response)
      })
      this.adminreadMessage()
    },
    openSession: function() {
      this.$emit('openSession')
      const payload = {
        userid: this.selectedUser.userid,
        pageid: this.$store.state.livechat.pageid,
        user: this.selectedUser
      }
      this.socket.emit('livechat:forward-startconversation', payload, response => {
        /* Handle response, if any */
        console.error('[response]: ', response)
      })
      this.adminreadMessage()
    },
    adminreadMessage() {
      let data = {
        adminid: this.selectedUser.userid,
        pageid: this.$store.state.livechat.pageid,
        app: this.selectedUser.app,
        context: this.selectedUser.context
      }
      if (this.selectedUser.userid || this.selectedUser.id) {
        data.userid = this.selectedUser.userid || this.selectedUser.id
        data.type = 'user'
      } else {
        data.userid = this.selectedUser.group_id
        data.type = 'group'
      }
      this.socket.emit('livechat:forward-adminreadchat', data, response => {
        /* Handle response, if any */
        console.error('[response]: ', response)
      })
    },
    onQuote(message, parsedMessage) {
      this.quote = {
        message,
        parsedMessage
      }
      this.adminread = true
    },
    async retrieveChat() {
      this.$store.dispatch('loading')
      this.messages = []
      await new Promise(resolve => setTimeout(resolve, 500))
      await this.$store.dispatch('syncFbCoversation', {
        id: this.selectedUser.userid,
        isChecked: true
      })
      this.allowChecked = false
      await this.getUserMessages(this.offset, this.limit, false)
      await this.gotobottom()
      await new Promise(resolve => setTimeout(resolve, 500))
      this.$store.dispatch('loading')
    },
    async unreadMessage() {
      let data = {
        adminid: this.selectedUser.userid,
        pageid: this.$store.state.livechat.pageid,
        app: this.selectedUser.app,
        context: this.selectedUser.context
      }

      if (this.selectedUser.group_id && this.selectedUser.app === 'line') {
        data.userid = this.selectedUser.group_id
        data.type = 'group'
      } else if (this.selectedUser.userid || this.selectedUser.id) {
        data.userid = this.selectedUser.userid || this.selectedUser.id
        data.type = 'user'
      } else {
        data.userid = this.selectedUser.group_id
        data.type = 'group'
      }
      await this.$store.dispatch('unreadChat', data)
      this.socket.emit('livechat:forward-adminunreadchat', data, response => {
        /* Handle response, if any */
        console.error('[response]: ', response)
      })
      this.adminread = false
    },
    setRead() {
      this.adminread = true
    },
    gotoLink() {
      const link = `https://blog.zwiz.app/all-features-on-all-in-1-chat/`
      window.open(link, '_blank')
    },
    async retrieveTags() {
      this.$store.dispatch('loading')
      await new Promise(resolve => setTimeout(resolve, 500))
      await this.$store.dispatch('syncFbTags', {
        id: this.selectedUser.userid
      })
      EventBus.$emit('update:tags')
      await new Promise(resolve => setTimeout(resolve, 500))
      this.$store.dispatch('loading')
    },
  },
  watch: {
    selectedUser: function(newVal, oldVal) {
      // this.selectedUser = newVal
      if (newVal == null || oldVal == null || oldVal != newVal) {
        this.resetChatlog()
        this.getLastedMessages()
      }
    },
    selectedBot: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.selectedUser = null
        this.resetChatlog()
      }
    }
  },
  beforeDestroy: function() {
    //this.log('clear')
    this.isDestroy = true
    if (this.timer) clearInterval(this.timer)
    document.removeEventListener('scroll', null, false)
  }
}
</script>

<style lang="scss" scoped>
.btn-back i {
  line-height: 0;
}
</style>

<style lang="scss">
#chatbox .v-toolbar__extension {
  height: 25px !important;
  background-color: red;
}
.quote-box {
  min-height: 40px;
  position: relative;
  background: white;
  border-top: 1px solid #eee;
  padding-top: 15px;
  padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-chatbox.vue